import React from 'react';
import './PageLoader.css';

const PageLoader: React.FC = () => {
  return (
    <div className="page-loader-overlay">
      <div className="page-loader">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 text-muted">Loading...</div>
      </div>
    </div>
  );
};

export default PageLoader;
















